import React from "react";
import Icon from "../icon/Icon";
const GalleryButton = (props) => {
  const { onClick, direction } = props;
  const rotation = direction === "left" ? 0 : 180;
  return /* @__PURE__ */ React.createElement("button", { className: "gallery-button", onClick }, /* @__PURE__ */ React.createElement(Icon, { icon: "galleryArrow", rotation }));
};
export default GalleryButton;
